// extracted by css-extract-rspack-plugin
var _1 = "column-name-rTOJZB";
var _2 = "column-name-rTOJZB";
var _3 = "filter-mV2jZF";
var _4 = "table-yvPbMq";
export { _1 as "column-name", _2 as "columnName", _3 as "filter", _4 as "table" }
